<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <template v-if="baseUrl">
        <img style="width: 100%; max-width: 255px" ref="answer" :src="baseUrl" />
      </template>
      <div class="primary--text caption">Line Image Map</div>
      <v-btn color="primary" depressed @click="showModal">{{ $t('Edit') }}</v-btn>
      <v-dialog v-model="show" width="1000" persistent>
        <v-card>
          <v-layout>
            <v-flex>
              <h3 class="primary--text pa-2">Line Image Map</h3>
            </v-flex>
            <v-flex>
              <div class="text-xs-right">
                <v-btn flat fab small @click="oncancel">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-card-text>
            <intent-line-image-map-message
              v-if="show"
              :image_url_edit="baseUrl"
              :altText="altText"
              v-model="message"
              @onsave="onsave"
              @oncancel="oncancel"
            ></intent-line-image-map-message>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('This messages will not be shown on ') + $t('facebook') + $t('and') + $t('instagram') }}
    </div>
  </div>
</template>

<script>
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
import jsonFormatter from 'json-string-formatter'
export default {
  props: ['value'],
  data: function() {
    return {
      show: false,
      message: null,
      baseUrl: null,
      altText: 'This is an imagemap'
    }
  },
  components: {
    IntentLineImageMapMessage
  },
  mounted: function() {
    var vm = this
    vm.baseUrl = vm.value.baseUrl
    vm.message = jsonFormatter.format(JSON.stringify(vm.value))
    vm.cached_message = jsonFormatter.format(JSON.stringify(vm.value))
  },
  methods: {
    showModal() {
      this.altText = this.value.altText
      this.show = true
    },
    oncancel: function() {
      this.show = false
      this.message = this.cached_message
    },
    onsave: function() {
      var vm = this

      vm.$emit('input', JSON.parse(vm.message))
      vm.message = jsonFormatter.format(vm.message)
      vm.show = false
      vm.cached_message = vm.message
    }
  },
  watch: {
    value: function(newVal) {
      var vm = this
      vm.baseUrl = newVal.baseUrl
      vm.altText = newVal.altText
      this.message = jsonFormatter.format(JSON.stringify(newVal))
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineImageMap.vue